module.exports = __webpack_public_path__ + "static/media/icon_eventos_publicidaddigital.9b4af445.svg";